import type { FaireProductEntity } from "../../entity_types/product";

export const p_45583xkdbf: FaireProductEntity = {
  token: "p_45583xkdbf",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE DUSTY BLUE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/266e7b81e53fd040485697025059473c3c4675d7c99cd2be8085f23fa9928eb7.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:55.065Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
